"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstallmentBillingPanelCms = /** @class */ (function () {
    function InstallmentBillingPanelCms() {
        this.titleLabel = 'Installment billing';
        this.billingDescriptionLabel = 'Select a billing option for your eligible annual and/or '
            + 'one-time charges. Keep in mind that your choice can\'t be changed once your order is complete.';
        this.toggleButtonPayMonthlyLabel = '{0} payments';
        this.toggleButtonOneTimePaymentLabel = '1 payment';
        this.editCTALabel = 'Edit';
        this.editAriaLabel = 'Edit Installment Billing Option';
        this.cancelCTALabel = 'Cancel';
        this.updateCartCTALabel = 'Update cart';
        this.oneTimePaymentCTATxt = 'Pay one time';
        this.monthlyPaymentCTATxt = 'Pay monthly';
        this.monthlyInstallAmountLabel = '{0}/mo. for {1} months';
        this.oneTimeInstallAmountLabel = '{0} one-time on 1st bill';
        this.oneTimeInstallmentlabel = "You'll pay the full {0} with your first bill.";
        this.monthlyInstallmentlabel = "You'll pay {0} in 3 installments";
    }
    return InstallmentBillingPanelCms;
}());
exports.default = InstallmentBillingPanelCms;
//# sourceMappingURL=InstallmentBillingPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/InstallmentBillingPanel/InstallmentBillingPanel.cms.js
// module id = 2038
// module chunks = 8